import { render, staticRenderFns } from "./ReductionPlanTabs.vue?vue&type=template&id=fb018fdc"
import script from "./ReductionPlanTabs.vue?vue&type=script&lang=js"
export * from "./ReductionPlanTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports